import React, { useState, useImperativeHandle } from 'react';
import { Modal} from 'antd';
import NewsActivityArtFile from '../../../interview/NewsActivityArtFile';
import NewsActivityPicture from '../../../interview/NewsActivityPicture';
import NewsActivityVideo from '../../../interview/NewsActivityVideo';
import TaskUpload from '../../../../view/components/taskUpload/taskUpload';
import taskPic from '../images/taskPic.png';
import './index.scss';


const UploadPic = (props) => {

    const [visible, setVisible] = useState(false);
    const [taskId, setTaskId] = useState('');
    const [data, setData] = useState({})


    useImperativeHandle(props.refs, () => ({
        visible: visible,
        showUploadPic: showUploadPic,
    }))

    const handleOk = () => {
        handleCancel();
    }

    const handleCancel = () => {
        setVisible(false);
        props.search(1);
    }

    const showUploadPic = (data) => {
        setData(data)
        setTaskId(data.id);
        setVisible(true);
    }


    const newRelate = () => {
        setVisible(false);
        props.selectManuscriptPool.current.showTask({taskTitle: '关联任务', topBtn: true});

    }


   const { title } = props;

   const renderContent = () => {
       if(props.title === '附件池'){
           return  <TaskUpload
           fileType={4}
           icons={["download", "delete"]}
           taskId={data.id}
           data={data}
       />
       }
       if(props.title === '图片池'){
           return  <TaskUpload
           fileType={2}
           icons={["eye", "download", "delete"]}
           taskId={data.id}
           data={data}
       />
        //    return <NewsActivityPicture data={{id: taskId}} />
       }
       if(props.title === '视频池'){
           return  <TaskUpload
           fileType={3}
           icons={["play", "download", "delete"]}
           taskId={data.id}
           data={data}
       />
        //    return <NewsActivityVideo data ={{id: taskId}} />
       }
   }

   console.log(data)

    return (
        <Modal
            className="pic-upload-modal"
            title={title === '图片池' ? '上传图片' :( title === '视频池' ? '上传视频' : '上传附件')}
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
            width="1000px"
        >
            {
                props.taskName ?  <div className="top">
                    <div className="pic">
                        <img src={taskPic} alt="" />
                    </div>
                <span>{props.taskName}</span>
            </div> : <>
            <span style={{ marginRight: 20}} className="btn" onClick={newRelate}>重新关联</span><span>{data.title}</span>
            </>
            }
            
            {renderContent()}
                
            
        </Modal>
    )
}



export default UploadPic